import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogData';
import BlogCard from '../components/BlogCard';
import SEO from '../components/SEO'; 

const Home = () => {
  // Sort blog posts by date (newest first) and take latest 3
  const latestPosts = [...blogPosts]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  return (
    <>
      {/* SEO Component with custom metadata for homepage */}
      <SEO 
        title="Franklin Fernandez | Full Stack Developer & Graphic Designer"
        description="17+ years of experience in UI/UX, PHP, Laravel, and graphic design. Available for remote work nationwide."
        keywords="full stack developer, graphic designer, UI/UX, PHP, Laravel, remote developer"
      />
      
      <main>
      {/* Hero Section */}
      <section id="home" className="hero-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="hero-content">
                <p>Hello! I'm Franklin</p>
                <h1 className="mt-3 mt-md-4 mb-md-5">Creating impactful experiences on <span className="text-secondary">visual design</span></h1>
                <div className="row">
                  <div className="col-md-6 order-2 order-md-1">
                    <a className="btn btn-dark btn-lg rounded-pill" href="mailto:fernandez954@gmail.com" role="button">Let's Talk
                      <i className="icon bi bi-arrow-right ms-1"></i>
                    </a>
                  </div>
                  <div className="col-md-6 order-1 order-md-2">
                    <p className="lead">I transform ideas into impactful digital experiences, delivering innovative solutions that elevate brands and captivate audiences around the world.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-bg">
          <img className="img-fluid circle-1" alt="Background 1" src="/assets/img/hero-bg-1.svg" />
          <img className="img-fluid circle-2" alt="Background 2" src="/assets/img/hero-bg-2.svg" />
        </div>
      </section>

      {/* Selected Works Section */}
      <section className="works position-relative p-0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="intro d-flex justify-content-between align-items-center">
                <h2 className="title h3">Selected Works</h2>
                <Link className="btn btn-outline-dark" to="/works">View All
                  <i className="icon bi bi-arrow-right-short"></i>
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="stack-wrapper">
              {/* Portfolio items - we'll map these from data in the complete version */}
              <div className="stack-item">
                <div className="card portfolio-item layout-2 scale has-shadow">
                  <div className="image-holder">
                    <Link className="card-thumb" to="/portfolio/app-redesign">
                      <img loading="lazy" className="img-fluid" alt="App Redesign" src="/assets/img/case-1.webp" />
                    </Link>
                    <div className="card-overlay">
                      <div className="heading">
                        <h3 className="h4 title mt-2 mt-md-3 mb-3">App Redesign</h3>
                        <div className="show-project">
                          <div className="card-terms">
                            <span className="terms badge outlined">App Design</span>
                            <span className="terms badge outlined">UI/UX</span>
                          </div>
                          <div className="project-link">
                            <Link to="/portfolio/app-redesign">Show Project</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Repeat for other portfolio items */}
              <div className="stack-item">
                <div className="card portfolio-item layout-2 scale has-shadow">
                  <div className="image-holder">
                    <Link className="card-thumb" to="/portfolio/app-redesign">
                      <img loading="lazy" className="img-fluid" alt="App Redesign" src="/assets/img/case-2.webp" />
                    </Link>
                    <div className="card-overlay">
                      <div className="heading">
                        <h3 className="h4 title mt-2 mt-md-3 mb-3">App Redesign</h3>
                        <div className="show-project">
                          <div className="card-terms">
                            <span className="terms badge outlined">App Design</span>
                            <span className="terms badge outlined">UI/UX</span>
                          </div>
                          <div className="project-link">
                            <Link to="/portfolio/app-redesign">Show Project</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="stack-item">
                <div className="card portfolio-item layout-2 scale has-shadow">
                  <div className="image-holder">
                    <Link className="card-thumb" to="/portfolio/app-redesign">
                      <img loading="lazy" className="img-fluid" alt="App Redesign" src="/assets/img/case-3.webp" />
                    </Link>
                    <div className="card-overlay">
                      <div className="heading">
                        <h3 className="h4 title mt-2 mt-md-3 mb-3">App Redesign</h3>
                        <div className="show-project">
                          <div className="card-terms">
                            <span className="terms badge outlined">App Design</span>
                            <span className="terms badge outlined">UI/UX</span>
                          </div>
                          <div className="project-link">
                            <Link to="/portfolio/app-redesign">Show Project</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="stack-item">
                <div className="card portfolio-item layout-2 scale has-shadow">
                  <div className="image-holder">
                    <Link className="card-thumb" to="/portfolio/app-redesign">
                      <img loading="lazy" className="img-fluid" alt="App Redesign" src="/assets/img/case-4.webp" />
                    </Link>
                    <div className="card-overlay">
                      <div className="heading">
                        <h3 className="h4 title mt-2 mt-md-3 mb-3">App Redesign</h3>
                        <div className="show-project">
                          <div className="card-terms">
                            <span className="terms badge outlined">App Design</span>
                            <span className="terms badge outlined">UI/UX</span>
                          </div>
                          <div className="project-link">
                            <Link to="/portfolio/app-redesign">Show Project</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="content">
                <h2 className="title reveal-text mt-0">Helping brands achieve digital mastery of creative innovation and strategic planning.</h2>
              </div>
              <div className="wrapper">
                <p className="sub-title">Transforming ideas into digital realities by blending strategic insights with innovative design, helping brands thrive in a rapidly evolving digital landscape.</p>
                <Link to="/about" className="btn btn-outline-dark">About Me
                  <i className="icon bi bi-arrow-right ms-1"></i>
                  <span></span>
                </Link>
              </div>
            </div>
          </div>
          <div className="row service-wrapper items mt-4 mt-md-5">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="item d-flex align-items-start">
                <div className="item-count fs-2 me-3">01</div>
                <div className="content">
                  <h3 className="h4 mt-0">Full-Stack</h3>
                  <p>I craft distinctive brand identities that resonate and endure. Through strategic insight and meticulous design, I build a unified visual language that captures your essence and speaks to your audience.</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="item d-flex align-items-start">
                <div className="item-count fs-2 me-3">02</div>
                <div className="content">
                  <h3 className="h4 mt-0">Graphic Design UX/UI</h3>
                  <p>I craft distinctive brand identities that resonate and endure. Through strategic insight and meticulous design, I build a unified visual language that captures your essence and speaks to your audience.</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="item d-flex align-items-start">
                <div className="item-count fs-2 me-3">03</div>
                <div className="content">
                  <h3 className="h4 mt-0">Social Media</h3>
                  <p>I craft distinctive brand identities that resonate and endure. Through strategic insight and meticulous design, I build a unified visual language that captures your essence and speaks to your audience.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Brands marquee omitted for brevity */}
      </section>

      {/* Awards Section */}
      <section className="awards sticky primary-bg">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-12 col-lg-3">
              <div className="intro">
                <h2 className="h3 title">Awards &amp; Recognition</h2>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <ul className="list-group list-group-flush">
                {/* Award items omitted for brevity */}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="blog">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="intro d-flex justify-content-between align-items-center">
                <h2 className="h3 title">Insights</h2>
                <Link className="btn btn-outline-dark" to="/blog">View All
                  <i className="icon bi bi-arrow-right-short"></i>
                </Link>
              </div>
            </div>
          </div>
          <div className="row items">
            {latestPosts.map((post) => (
              <div className="col-md-4" key={post.id}>
                <BlogCard 
                  image={post.image}
                  title={post.title}
                  date={post.date}
                  tags={post.tags}
                  slug={post.slug}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta border-top border-light-subtle">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-12 col-md-10 col-lg-7">
              <h2 className="title mb-0 mb-md-2">Let's Create Something</h2>
              <div className="cta-text">
                <span className="line-item h2">Together</span>
                <span className="line"></span>
                <a href="mailto:fernandez954@gmail.com" className="btn btn-dark">Get In Touch!
                  <i className="icon bi bi-arrow-right ms-1"></i>
                  <span></span>
                </a>
              </div>
              <div className="socials mt-5">
                <nav className="nav justify-content-center">
                  <a className="nav-link swap-icon" href="/#">Instagram
                    <i className="icon rotate bi bi-arrow-right-short"></i>
                  </a>
                  <a className="nav-link swap-icon" href="/#">Twitter
                    <i className="icon rotate bi bi-arrow-right-short"></i>
                  </a>
                  <a className="nav-link swap-icon" href="/#">LinkedIn
                    <i className="icon rotate bi bi-arrow-right-short"></i>
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
}

export default Home;